<div class="container-narrow my-5">
  <div class="col-12">
    <h1 class="mb-4 pre-wrap"
        [translate]="'AUTH.LOGIN-REQUIRED.PAGE-TITLE'"></h1>
    <p class="mb-5 pre-wrap"
       [translate]="'AUTH.LOGIN-REQUIRED.PAGE-DESCRIPTION'">
    </p>
    <button type="button"
            (click)="openSignInPopup()"
            class="btn btn-outline-primary px-4"
            [translate]="'AUTH.LOGIN-REQUIRED.BUTTON-SIGN-IN'">
    </button>
  </div>
</div>
